import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CHECKIN_SEARCH_RESULT_STORE_NAME, CheckinSearchResultState } from './checkin-search-result.state';

/** Select CheckinSearchResult State */
export const selectCheckinSearchResultState = createFeatureSelector<CheckinSearchResultState>(
  CHECKIN_SEARCH_RESULT_STORE_NAME
);

/** Select CheckinSearchResult isPending status */
export const selectCheckinSearchResultIsPendingStatus = createSelector(
  selectCheckinSearchResultState,
  (state) => !!state.isPending
);

/** Select CheckinSearchResult isFailure status */
export const selectCheckinSearchResultIsFailureStatus = createSelector(
  selectCheckinSearchResultState,
  (state) => !!state.isFailure
);
